export default __webpack_public_path__ + "static/Digital-Transformation-d077e8c500fc7185dfee60933c2e0d9e.webp";